/**
 * @generated SignedSource<<872292873594d9a0b36c0fe4a6ee7b67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobSkillsField_SkillsQuery$variables = {
  editable: boolean;
};
export type JobSkillsField_SkillsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JobSkillsFields_SkillsFragment">;
};
export type JobSkillsField_SkillsQuery = {
  response: JobSkillsField_SkillsQuery$data;
  variables: JobSkillsField_SkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "editable"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobSkillsField_SkillsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobSkillsFields_SkillsFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobSkillsField_SkillsQuery",
    "selections": [
      {
        "condition": "editable",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              }
            ],
            "concreteType": "SkillConnection",
            "kind": "LinkedField",
            "name": "skills",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Skill",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industries",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawId",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "skills(first:1000)"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6ca65793a6b2800ab9aba43d525d0397",
    "id": null,
    "metadata": {},
    "name": "JobSkillsField_SkillsQuery",
    "operationKind": "query",
    "text": "query JobSkillsField_SkillsQuery(\n  $editable: Boolean!\n) {\n  ...JobSkillsFields_SkillsFragment\n}\n\nfragment JobSkillsFields_SkillsFragment on Query {\n  skills(first: 1000) @include(if: $editable) {\n    edges {\n      node {\n        id\n        name\n        industries {\n          rawId\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb93578a9a3b704720e3ca5a5faa3fd1";

export default node;
